import { Component, OnInit, Input } from '@angular/core';
import { SortService } from '../sort.service';
import { PageService } from '../page.service';

@Component({
  selector: 'app-tag-sort',
  templateUrl: './tag-sort.component.html',
  styleUrls: ['./tag-sort.component.css']
})
export class TagSortComponent implements OnInit {
  @Input() tp: string;
  @Input() name: string;
  @Input() id: string;

  constructor(
    private ss: SortService,
    private pgs: PageService
  ) { }

  ngOnInit() {
  }

  get ssTp() {
    return this.id || this.tp;
  }

  get number() {
    let n = this.ss.position(this.ssTp) + 1;
    if (n)
      return `${n}. `;
    return '';
  }

  get isPrimary() {
    return this.ss.position(this.ssTp) == 0;
  }

  get isSecondary() {
    return this.ss.position(this.ssTp) > 0;
  }

  switch(event) {
    this.ss.clearCache();
    this.pgs.currentStart = 0;
    this.ss.switch(this.ssTp, event.ctrlKey);
  }


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag-sort/tag-sort.component.ts